export enum GeneralStatus {
	Active = "Active",
	InActive = "InActive",
	Delete = "Delete",
}

export enum GeneralStatusId {
	Active = 1,
	InActive = 2,
	Delete = 3,
}
